import { render, staticRenderFns } from "./sticker.vue?vue&type=template&id=308754c0&scoped=true"
import script from "./sticker.vue?vue&type=script&lang=js"
export * from "./sticker.vue?vue&type=script&lang=js"
import style0 from "./sticker.vue?vue&type=style&index=0&id=308754c0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308754c0",
  null
  
)

export default component.exports